// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"section_wrapper_9z6qdgn"};